import { getAuthorizationProperties } from "./authorizationHelper";
import { UserData } from "../actions/authentificationActions";
import { ITso } from "../containers/UsersDashboard/CreateUserForm";
import { UsersState } from "../store/usersReducer";
import { ChangePasswordDto } from "../containers/UserProfile/ChangePassword";

export async function updateUser(userDto: UserData) {
    return fetch(`users/${userDto.guid}`, {
        method: "PUT",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(userDto),
    });
}

export async function getUsers(): Promise<UserData[]> {
    const users = await fetch("users", {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return users.json();
}

export async function getUsersAsProps(): Promise<UsersState[]> {
    const users = await fetch("users/props", {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return users.json();
}

export async function deleteUser(guid: string): Promise<Response> {
    return fetch(`users/${guid}`, {
        method: "DELETE",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}

export async function addUser(userDto: UserData): Promise<Response> {
    return fetch("users/createUser", {
        method: "POST",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(userDto),
    });
}

export async function getTsos(): Promise<ITso[]> {
    const res = await fetch("users/tsos", {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return res.json();
}

export async function isLocalLoginEnabledForUser(userGuid: string): Promise<boolean> {
    const res = await fetch(`users/isLocalAuthenticateAvailable/${userGuid}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return (await res.json()).enabled;
}

export async function changeUserPassword(passwordDto: ChangePasswordDto) {
    return fetch(`users/${passwordDto.userGuid}/changePassword`, {
        method: "PUT",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(passwordDto),
    });
}

export async function changeUserRole(userGuid: string, role: string) {
    return fetch(`users/${userGuid}/changeRole?role=` + role, {
        method: "PUT",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}

export async function changeUserTso(userGuid: string, tso: string) {
    return fetch(`users/${userGuid}/changeTso?tso=` + tso, {
        method: "PUT",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}

export async function logoutUser() {
    return fetch(`users/logout`, { method: "POST", ...getAuthorizationProperties({}) });
}

export async function toggleUserEnabled(userGuid: string) {
    return fetch(`users/${userGuid}/toggleEnabled`, {
        method: "PATCH",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}

export async function toggleLocalLoginEnabled(userGuid: string) {
    return fetch(`users/${userGuid}/toggleLocalLoginEnabled`, {
        method: "PATCH",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}
